import Header from './components/Header';
import Hero from './components/Hero';
import GuidedBooking from './components/GuidedBooking';
import FeaturedProperties from './components/FeaturedProperties';
import Concierge from './components/Concierge';
import Experiences from './components/Experiences';
import BookingCta from './components/BookingCta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="bg-background-50 text-foreground-900 font-body">
      <Header />
      <Hero />
      <GuidedBooking />
      <FeaturedProperties />
      <Concierge />
      <Experiences />
      <BookingCta />
      <Footer />
    </main>
  );
}
